import { X } from "lucide-react";
import { BOOK } from "@/data/book";
import TableOfContents from "@/components/TableOfContents";

export default function MobileTocDrawer({ activeId, onSelect, onClose }) {
  const items = [
    { id: "before-you-begin", title: "Before You Begin", n: "Prologue" },
    ...BOOK.chapters.map((c) => ({ id: c.id, title: c.title, n: `Truth ${String(c.number).padStart(2, "0")}` })),
    { id: "in-closing", title: "In Closing", n: "Epilogue" },
  ];

  return (
    <div className="lg:hidden fixed inset-0 z-50 bg-background/95 backdrop-blur-sm overflow-y-auto" data-testid="mobile-toc">
      <div className="px-6 py-8 max-w-md mx-auto">
        <div className="flex items-center justify-between mb-6">
          <p className="font-display text-2xl">Contents</p>
          <button
            type="button"
            onClick={onClose}
            data-testid="mobile-toc-close"
            className="h-10 w-10 rounded-full bg-muted flex items-center justify-center"
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <TableOfContents activeId={activeId} onSelect={onSelect} />
        <div className="lg:hidden space-y-1 mt-4">
          {items.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => onSelect(item.id)}
              className={`block w-full text-left font-ui text-sm py-2 px-3 rounded-md ${
                activeId === item.id ? "bg-primary/10 text-primary font-semibold" : "text-foreground/80 hover:bg-muted"
              }`}
            >
              <span className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground block">{item.n}</span>
              {item.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
